export const GroupPaymentBadgeCollection = ['DROP_OUT_AFTER_ENROLLMENT']
